// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-3c2df5ea] .van-cell {
  padding-left: 0;
  padding-right: 0;
}
[data-v-3c2df5ea] .van-tabbar-item__icon img {
  height: auto;
}

/* 用户信息卡片基础样式 */
.user-info-card[data-v-3c2df5ea] {
  /* 确保动画平滑 */
  will-change: transform, opacity;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
